import { createContext } from 'react';

export interface SheetVisibilityContextType {
    isSheetOpen: boolean;
    setIsSheetOpen: (open: boolean) => void;
}

export const SheetVisibilityContext = createContext<
  SheetVisibilityContextType | undefined
>(undefined);
